import { Component, OnInit, ViewChild } from '@angular/core';
import { Device            } from 'src/app/beans/device/device.bean';
import { DeviceDetail      } from 'src/app/beans/device/device.detail.bean';
import { User              } from 'src/app/beans/login/user/user.bean';
import { Site              } from 'src/app/beans/site/site.bean';
import { DeviceSelect } from 'src/app/components/select/device/device-select/device.select';
import { HandlerManager    } from 'src/app/managers/handler/handler.manager';
import { LoadingManager    } from 'src/app/managers/loading/loading.manager';
import { SessionManager    } from 'src/app/managers/session/session.manager';

@Component({
  selector: 'device.management.page',
  templateUrl: './device.management.page.html',
  styleUrls: ['./device.management.page.scss']
})
export class DeviceManagementPage implements OnInit 
{
  device: Device
  site  : Site
  
  values: DeviceDetail

  _devMan: DeviceSelect
  @ViewChild('deviceManager') set _device( _device: DeviceSelect ) {
    this._devMan = _device
  }

  //-----------------------------------------------------------------------
  
  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) {}

  ngOnInit(): void 
  {}

  //-----------------------------------------------------------------------

  setDevice(el: any)
  {
    this.device = el

    if(!el) 
      this.values = null
    else
      this.init()
  }

  setSite(el: any)
  {
    this.site = el
  }

  async init()
  {
    this.values = await this.retriveValues()
  }

  //-----------------------------------------------------------------------

  async retriveValues()
  {
    const user = this._session.user().get()

    if ( !User.isKind(user) ) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
        response = await this._handler.device().detail((user as User).token, this.device.id)
    
    this._loader.stop()

    if (!response       ) return 
    if (!response.object) return
    
    return response.object as DeviceDetail
  }

  async reloadData(){
    //deviceManager?.refreshData(siteManager?.currentValue)
    const currentDev = this.device
    console.log(currentDev);
    
    await this._devMan.refreshData( this.site ) 

    this._devMan.selectElement( currentDev )

  }
}
